module.exports = __webpack_public_path__ + "img/15.60f7af77.jpg";